import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
  handleFetchFulfilled,
} from "redux/helpers/fetching"
import {
  fetchSubscriptions,
  fetchSubscription,
  createSubscription,
  upgradeSubscription,
  cancelSubscription,
} from "redux/features/subscription/subscriptionThunk"

const subscriptionAdapter = createEntityAdapter()
export const initialState = subscriptionAdapter.getInitialState({
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})
export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSubscriptions.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchSubscriptions.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchSubscriptions.fulfilled, (state, { payload }) => {
        subscriptionAdapter.setAll(state, payload)
        handleCollectionFetchFulfilled(state)
      })
      .addCase(fetchSubscription.pending, (state) => handleFetchPending(state))
      .addCase(fetchSubscription.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(fetchSubscription.fulfilled, (state, { payload }) => {
        subscriptionAdapter.setOne(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(createSubscription.pending, (state) => handleFetchPending(state))
      .addCase(createSubscription.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(createSubscription.fulfilled, (state, { payload }) => {
        if (payload.subscription) {
          subscriptionAdapter.setOne(state, payload.subscription)
        }
        handleFetchFulfilled(state)
      })
      .addCase(upgradeSubscription.pending, (state) =>
        handleFetchPending(state),
      )
      .addCase(upgradeSubscription.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(upgradeSubscription.fulfilled, (state, { payload }) => {
        if (payload.subscription) {
          subscriptionAdapter.setOne(state, payload.subscription)
        }
        handleFetchFulfilled(state)
      })
      .addCase(cancelSubscription.pending, (state) => handleFetchPending(state))
      .addCase(cancelSubscription.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(cancelSubscription.fulfilled, (state, { payload }) => {
        if (payload.subscription) {
          subscriptionAdapter.setOne(state, payload.subscription)
        }
        handleFetchFulfilled(state)
      })
  },
})

export const {
  selectTotal,
  selectAll: selectSubscriptions,
  selectById: selectSubscriptionById,
} = subscriptionAdapter.getSelectors(
  (state: RootState) => state.features.subscription,
)

export const selectFetchStatus = (state: RootState) =>
  state.features.subscription.fetchStatus
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.subscription.fetchCollectionStatus

export default subscriptionSlice.reducer
